module.exports = __webpack_public_path__ + "img/posture_perfect5.13c5438f.png";